import "../../assets/css/CustomToast.scss";

function CustomToast({ title, description }) {
    return (
    <div className="custom-toast">
        <div className="custom-toast-title">{title}</div>
        {description && (
        <div className="custom-toast-description">{description}</div>
        )}
    </div>
    );
};
export default CustomToast;
